import { PlanWithLimits } from '../../shared/models/plans';
import { PlanFeatureCellValue } from './plans-table/plans-table.model';

export const alwaysCheckedCellValue = (_: any): PlanFeatureCellValue => ({ check: true });

export const daysCellValue = (days?: number): PlanFeatureCellValue | null => {
  if (days === 0) {
    return null;
  }
  if (!days) {
    return {
      text: 'UNLIMITED'
    };
  }
  return {
    text: 'PLANS.DAYS',
    from: days
  };
};

export const priceCellValue = (price?: number): PlanFeatureCellValue | null => {
  if (price === 0) {
    return null;
  }
  if (!price) {
    return null;
  }
  return {
    text: `$${price}`
  };
};

export const maxCellValue = (plan: PlanWithLimits, value?: number): PlanFeatureCellValue | null => {
  if (plan.flatPriceCents === 0) {
    return {
      text: 'PLANS.MAX',
      to: value
    };
  }
  if (!value) {
    return null;
  }
  return {
    text: `${value}`
  };
};

export const upToCellValue = (value?: number): PlanFeatureCellValue | null => {
  if (value === 0) {
    return null;
  }
  if (!value) {
    return {
      text: 'UNLIMITED'
    };
  }
  return {
    text: 'PLANS.UP_TO',
    to: value
  };
};

export const rawNumericCellValue = (number?: number): PlanFeatureCellValue | null => {
  if (number === 0) {
    return null;
  }
  if (!number) {
    return {
      text: 'UNLIMITED'
    };
  }
  return {
    text: `${number}`
  };
};

export const inboundStrategiesCellValue = (strategies: string[]): PlanFeatureCellValue | null => {
  if (strategies.length < 3) {
    return {
      text: 'PLANS.OUT_OF',
      from: strategies.length,
      to: 3
    };
  }
  return {
    text: 'ALL'
  };
};

export const booleanCheckCellValue = (value?: boolean): PlanFeatureCellValue | null => {
  return value ? { check: true } : null;
};

export const permissionCheckCellValue = (plan: PlanWithLimits, permission: string): PlanFeatureCellValue | null => {
  if (plan.isEnterprise) {
    return alwaysCheckedCellValue(plan);
  }
  if (!plan.extraPermissions || !plan.extraPermissions.length) {
    return null;
  }
  return booleanCheckCellValue(plan.extraPermissions.includes(permission));
};

export const requiresOutboundNumberCellValue = (plan: PlanWithLimits): PlanFeatureCellValue | null => {
  return booleanCheckCellValue(plan.didsLimit === undefined || plan.didsLimit > 0);
};
